import React, { createContext, useContext, useState, useEffect, useMemo } from 'react';
import { loadGameData } from '../services/DataService';

const DataContext = createContext(null);
const HomebrewOverrideContext = createContext(() => {});

export const useDaggerheartData = () => useContext(DataContext);
export const useHomebrewOverride = () => useContext(HomebrewOverrideContext);

export const DataProvider = ({ children }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [homebrewCardOverrides, setHomebrewCardOverrides] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      const gameData = await loadGameData();
      setData(gameData);
      setLoading(false);
    };

    fetchData();
    // Empty dependency array ensures data is fetched only once on initial mount.
  }, []);

  const mergedData = useMemo(() => {
    if (!data) return data;
    if (Object.keys(homebrewCardOverrides).length === 0) return data;
    return {
      ...data,
      domainCards: {
        ...data.domainCards,
        ...homebrewCardOverrides,
      },
    };
  }, [data, homebrewCardOverrides]);

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <p className="text-xl font-semibold animate-pulse">Loading Daggerheart Compendium...</p>
      </div>
    );
  }

  return (
    <HomebrewOverrideContext.Provider value={setHomebrewCardOverrides}>
      <DataContext.Provider value={mergedData}>
        {children}
      </DataContext.Provider>
    </HomebrewOverrideContext.Provider>
  );
};
